import _ from 'underscore';

import { createNumericAdjustmentViewClass, createErrorOnClickWithDependentFieldClass } from '../custom-controls/index';
import { getCurrencyConvertorTemplateFromModel } from '../options-section/index';

function getBCCDecreaseValueByMarket(market) {
  switch (market) {
    case 'US':
    case 'AT':
    case 'AU':
    case 'BE':
    case 'CA':
    case 'CH':
    case 'CN':
    case 'CZ':
    case 'DE':
    case 'DK':
    case 'ES':
    case 'FI':
    case 'FR':
    case 'GB':
    case 'IE':
    case 'IL':
    case 'IN':
    case 'IT':
    case 'JP':
    case 'MX':
    case 'NL':
    case 'NO':
    case 'NZ':
    case 'SE':
    case 'TW':
      return 67;
    default: return 50;
  }
}

export function getBidFields({
  i18n,
  logTrace,
  model,
  permissions,
  market,
  minAdjust,
  maxAdjust,
  shouldShowCurrencyConvertor = false,
  importAccountCurrencyTitle,
}) {
  const deviceTargetOptimizationEnabled = permissions.IsDeviceTargetOptimizationEnabled;
  let minAdjustTextValue = _.isNumber(minAdjust) ? minAdjust : parseInt(minAdjust, 10);
  minAdjustTextValue = Math.abs(minAdjustTextValue);

  if (logTrace) {
    logTrace('BCCForImportRecommendation: pilot=true');
    logTrace(`BCCForImportRecommWithSOW: pilot=true with market=${market}`);
  }

  return [
    {
      type: 'collapse',
      text: i18n.getString('Import_ImportOptions_BudgetsBids'),
      isExpanded: true,
      className: 'bid-budget-collapse scheduling-form',
      fields: _.compact([shouldShowCurrencyConvertor && {
        property: 'EnableAutoCurrencyConversion',
        control: getCurrencyConvertorTemplateFromModel(
          i18n,
          model,
          importAccountCurrencyTitle
        ),
        showLabel: false,
      }, {
        property: 'DefaultBidsBelowMinToAdCenterMinBid',
        message: permissions.IsImportAutoMinimumBidEnabled ? i18n.getString('Import_ImportOptions_SetMinBids_RecommendedBid') : i18n.getString('Import_ImportOptions_SetMinBids_Generic_WithRecommendedBid'),
        control: 'checkbox',
        showLabel: false,
      }, {
        property: 'AdjustmentForBids_EnableAdjustment',
        label: '',
        message: i18n.getString('AdjustmentForBids_EnableAdjustment'),
      }, {
        property: 'AdjustmentForBids_AdjustmentValue',
        control: createNumericAdjustmentViewClass(i18n, 'AdjustmentForBids_EnableAdjustment'),
        message: '',
        label: '',
        ariaLabel: i18n.getString('AdjustmentForBids_AdjustmentValue'),
        selectAriaLabel: i18n.getString('Import_ImportOptions_BidsAdjustment_Options'),
        validators: {
          number: {
            message: i18n.getString('RequiredNumber'),
          },
          range: {
            message: i18n.getString('Import_InvalidBidAdjustment')
              .replace('{0}', minAdjustTextValue)
              .replace('{1}', maxAdjust),
          },
        },
      }, {
        property: 'ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids',
        control: createErrorOnClickWithDependentFieldClass(i18n.getString('Import_ImportOptions_UpdateEntityRequiredWarning'), 'UpdateEntityPreferences'),
        showLabel: false,
        message: i18n.getString('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids_Bids'),
      }, {
        property: 'ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies',
        control: createErrorOnClickWithDependentFieldClass(i18n.getString('Import_ImportOptions_UpdateEntityRequiredWarning'), 'UpdateEntityPreferences'),
        showLabel: false,
        message: i18n.getString('ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids_BidStrategies'),
      }, {
        property: 'DefaultCampaignBudgetBelowMinToAdCenterMinBudget',
        message: i18n.getString('Import_ImportOptions_SetMinBudget_Generic'),
        control: 'checkbox',
        showLabel: false,
      }, {
        property: 'AdjustmentForCampaignBudgets_EnableAdjustment',
        label: '',
        message: i18n.getString('AdjustmentForCampaignBudgets_EnableAdjustment'),
      }, {
        property: 'AdjustmentForCampaignBudgets_AdjustmentValue',
        control: createNumericAdjustmentViewClass(i18n, 'AdjustmentForCampaignBudgets_EnableAdjustment'),
        message: '',
        label: '',
        ariaLabel: i18n.getString('AdjustmentForCampaignBudgets_AdjustmentValue'),
        selectAriaLabel: i18n.getString('Import_ImportOptions_BudgetsAdjustment_Options'),
        validators: {
          number: {
            message: i18n.getString('RequiredNumber'),
          },
          range: {
            message: i18n.getString('Import_InvalidBudgetAdjustment')
              .replace('{0}', minAdjustTextValue)
              .replace('{1}', maxAdjust),
          },
        },
        decreaseMaxNum: getBCCDecreaseValueByMarket(market),
        decreaseMaxNumMessageTemplate: i18n.getString('AdjustmentForCampaignBudgets_RecommendationMessage'),
        logTrace,
      }, {
        property: 'ImportUpdateEntityPreference_UpdateCampaignBudget',
        control: createErrorOnClickWithDependentFieldClass(i18n.getString('Import_ImportOptions_UpdateEntityRequiredWarning'), 'UpdateEntityPreferences'),
        showLabel: false,
        message: i18n.getString('ImportUpdateEntityPreference_UpdateCampaignBudget_BidSection'),
      }, {
        property: 'RaiseLowBidsToMinServingBidsForBsc',
        message: i18n.getString('Import_ImportOptions_SetMinShoppingCampaignBid'),
        control: 'checkbox',
        showLabel: false,
      }, deviceTargetOptimizationEnabled && {
        property: 'AutoDeviceBidOptimization',
        message: i18n.getString('Import_ImportOptions_AutoDeviceBidOptimization'),
        control: 'checkbox',
        showLabel: false,
      }]),
    },
  ];
}
